// import { CustomMenuItem } from 'helper/type/action.type';
import { ReactComponent as IconExclamation } from 'assets/images/exclamation-circle.svg';
import { ReactComponent as IconSwap } from 'assets/images/swap.svg';
// import { usePermissions } from 'AuthorizePermission';
// import { useFilterActions } from 'helper/common/permission.action.helper';
import { ACTION_TOURS } from './action-tour';

export const ACTION_TOUR_LIST = (t: (key: string) => string, record?: any) => {
  const baseActions = [
    {
      key: ACTION_TOURS.DETAIL,
      label: (
        <div className="action-item">
          <IconExclamation />
          <span>{t('common.actions.details')}</span>
        </div>
      )
    }
  ];

  // Only add STATUS_ACTION if tour status is not 'complete'
  if (!record || record.tourStatus !== 'complete') {
    baseActions.push({
      label: (
        <div className="action-item">
          <IconSwap />
          <span>{t('common.actions.tourStatus')}</span>
        </div>
      ),
      key: ACTION_TOURS.STATUS_ACTION
    });
  }

  return baseActions;
};

// export const useFilteredActionBookingList = (t: (key: string) => string): CustomMenuItem[] => {
//   const { hasPermission, permissions } = usePermissions();
//   const actions = ACTION_TOUR_LIST(t);
//   return useFilterActions(actions, permissions, hasPermission);
// };
